"use strict";

var _classCallCheck = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/classCallCheck");

var _possibleConstructorReturn = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/possibleConstructorReturn");

var _getPrototypeOf = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/getPrototypeOf");

var _inherits = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/inherits");

Object.defineProperty(exports, "__esModule", {
  value: true
});

var DataObjectConverter_1 = require("../../core/conversions/DataObjectConverter");

var AbstractReportConverter =
/*#__PURE__*/
function (_DataObjectConverter_) {
  _inherits(AbstractReportConverter, _DataObjectConverter_);

  function AbstractReportConverter() {
    _classCallCheck(this, AbstractReportConverter);

    return _possibleConstructorReturn(this, _getPrototypeOf(AbstractReportConverter).apply(this, arguments));
  }

  return AbstractReportConverter;
}(DataObjectConverter_1.DataObjectConverter);

exports.AbstractReportConverter = AbstractReportConverter;